import React, { Component } from 'react';


import './styles.css';


export default class notificationError extends Component {

    onClose = e => {
        this.props.onClose(false);
    };

    render() {
        if(!this.props.show) {
            return null;
        }
        return (
            <div className="notification-container">
                <p className="message-notification">Error: {this.props.message}</p>
            
                <i className="material-icons close-icon-notification" onClick={this.onClose}>close</i>
                
            </div>
        );

    }
    
}

